import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { langType, withLang } from '../../../i18n';
import {
  navigateTo
} from '../../../util';

const EditSurveyIconButton = ({
  route, surveyId, translate: t, disabled
}) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="actionButton icon--edit-event"
      title={t('common.edit')}
      onClick={() => navigateTo(navigate, route, surveyId)}
      disabled={disabled}
      data-cy="edit-survey-icon-button"
    />
  );
};
const {
  string
} = PropTypes;

EditSurveyIconButton.propTypes = {
  surveyId: string.isRequired,
  ...langType
};

export default withLang(EditSurveyIconButton);
